import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import DataTable from "components/common/table/DataTable";
import TableShimmer from "components/common/TableShimmer";
import { usePermission } from "hooks/usePermission";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAppliedCouponHistory } from "store/slices/couponSlice";
import { resetFilters, setFilter } from "store/slices/couponSlice";
import { ORDER_BY_OPTIONS, STATUS_OPTIONS } from "utils/constants";
import { getActionFlags } from "utils/getActionFlags";
import { formatUTCDate, getMinMaxDate } from "utils/utils";
import { useQueryParam } from "hooks/useQueryParam";
import { Link } from "react-router-dom";
import PageHeader from "components/common/PageHeader";

const AppliedCouponsHistory = ({ userId = "", isFromUserDetails = false }) => {
  const { t } = useTranslation();
  const { noPlans } = Icons || {};
  const dispatch = useDispatch();
  const { canAction } = usePermission();
  const { canView } = canAction("coupon");
  const coupon_id_qp = useQueryParam("coupon_id");

  const {
    loading,
    appliedCouponHistory: Coupons,
    filters: { keyword, dates, status, orderBy, coupon_id, user_id },
  } = useSelector((state) => state.Coupons);

  useEffect(() => {
    getAllData();
  }, [canView]);
  const getAllData = (page, action) => {
    const { isReset, isResetKeyword } = getActionFlags(action);

    const payload = {
      perPage: isFromUserDetails ? 100 : 50,
      pageNo: page || 1,
      status: isReset ? -1 : status,
      orderBy: isReset ? -1 : orderBy,
      couponId: coupon_id_qp ?? "",
      userId: userId ?? "",
      keyword: isResetKeyword ? "" : keyword || "",
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };

    dispatch(getAppliedCouponHistory(payload));
  };

  const handleReset = () => {
    dispatch(resetFilters());
    getAllData(1, { actionType: "RESET" });
  };

  const filtersList = [
    {
      key: "orderBy",
      placeholder: t("Order By"),
      type: "singleSelect",
      options: ORDER_BY_OPTIONS,
    },
  ];
  const columns = useMemo(
    () => [
      {
        header: t("Coupon Code"),
        key: "coupon",
        render: (value) => (
          <div className="ltr_text">{value?.couponCode ?? "-"}</div>
        ),
      },
      {
        header: t("Discount Amount"),
        key: "coupon",
        render: (value) => (
          <div className="d-flex justify-content-start">{value?.discountAmount ?? "-"}</div>
        ),
      },
      {
        header: t("User"),
        key: "user",
        render: (value) => (
          <div className="ltr_text">
            <p>{value?.name ?? "-"}</p>
            {!isFromUserDetails ? (
              <p>
                <Link to={`/customers/customer-details?id=${value._id}`}>
                  {value?.phone ?? "-"}
                </Link>
              </p>
            ) : (
              <p>{value?.phone ?? "-"}</p>
            )}
          </div>
        ),
      },

      {
        header: t("Applied Date"),
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value) ?? "-"}</div>
        ),
      },
    ],
    [t],
  );

  if (!canView) return null;

  return (
    <div
      className={`${!isFromUserDetails ? "page-content" : "customer_applied_coupon p-4"} coupons_page`}
    >
      {!isFromUserDetails && (
        <PageHeader isBackBtn={true} title={t("Applied Coupon History")} />
      )}
      <FilterBar
        keyword={keyword}
        setKeyword={(value) => dispatch(setFilter({ key: "keyword", value }))}
        keywordPlaceholder={t("Search by Coupon Code")}
        filters={filtersList}
        selectedFilters={{ keyword, status, orderBy, coupon_id, user_id }}
        onFilterUpdate={(key, value) => dispatch(setFilter({ key, value }))}
        onSearch={getAllData}
        onReset={handleReset}
        isDateRange={true}
        dates={dates}
        setDates={(value) => dispatch(setFilter({ key: "dates", value }))}
      />

      {loading && <TableShimmer rows={12} columns={6} />}

      {!loading && Coupons?.data?.length === 0 && (
        <NoDataFound title={t("No History Found")} icon={noPlans} />
      )}
      {!loading && Coupons?.data?.length > 0 && (
        <>
          <DataTable columns={columns} data={Coupons?.data} t={t} />
          {/* {!isFromUserDetails && ( */}
          <Paginations
            currentPage={Coupons?.currentPage}
            totalPages={Coupons?.totalPages}
            totalCount={Coupons?.totalCount}
            onPageChange={getAllData}
          />
          {/* )} */}
        </>
      )}
    </div>
  );
};

export default AppliedCouponsHistory;
